export var STATIC_URL = "https://static.vseth.ethz.ch";